import React, { useEffect, useState } from "react";
import { EmptyBox } from "../../../../../app/assets/icons";
import { Checkbox, Spin } from "antd";
import { Popover } from "@material-ui/core";
import moment from "moment-timezone";
import NotificationCheckbox from "./NotificationCheckbox";
import InfiniteScroll from "react-infinite-scroll-component";
import { httpService } from "../../../../../app/base/services/httpService.service";
import { useNotificationRedirect } from "../notificationContext/NotificationRedirect";
import { useNotificationStore } from "./useNotificationStore";

const getTimeDifference = (createdAt) => {
   const currentTime = moment();
   const createdAtDate = moment.utc(createdAt).tz(moment.tz.guess());

   const duration = moment.duration(currentTime.diff(createdAtDate));

   const calculateTime = [
      { label: "year", value: duration.years() },
      { label: "month", value: duration.months() },
      { label: "week", value: Math.floor(duration.days() / 7) },
      { label: "day", value: duration.days() % 7 },
      { label: "hour", value: duration.hours() },
      { label: "minute", value: duration.minutes() }
   ];

   for (const unit of calculateTime) {
      if (unit?.value > 0) {
         return `${unit?.value} ${unit?.label}${unit?.value > 1 ? "s" : ""} ago`;
      }
   }

   return "just now";
};



const NotificationPopover = ({
   notifications,
   notificationMetaData,
   user,
   toggleBell,
   handleCloseBell,
   // markAllNotificationsAsRead,
   // loadingMarkAllRead,
   // loadingMarkOneRead
   setPopoverUnreadCount,
   setPopoverUnreadCountAll,
   setPopoverIncCount
}) => {

   const {notificationData, setNotificationData, newNotification, setNewNotification} = useNotificationStore();
   const [hasMore, setHasMore] = useState(true);
   const [page, setPage] = useState(2)
   const [dataLoading, setDataLoading] = useState(false);
   const [activeTab, setActiveTab] = useState(1);
   const [pageCount, setPageCount] = useState(0);
   const [lastFetchedItems, setLastFetchedItems] = useState(0);

   const [loadingMarkAllRead, setLoadingMarkAllRead] = useState(false);
   // const [loadingMarkOneRead, setLoadingMarkOneRead] = useState({});
   const [loadingOneRead, setLoadingOneRead] = useState([]);

   const notificationRedirect = useNotificationRedirect();

   const redirectNotification = (notification) => {
      markRead(notification?.id);
      notificationRedirect(notification?.notificationType, notification?.entityId, notification?.workspaceId);
   }

   const markRead = async (id) => {
      // setLoadingMarkOneRead((prev) => ({
      //    ...prev,
      //    [id]: true
      // }))
      setLoadingOneRead((prev) => [...prev, id])

      await httpService.post('/Notifications/read', {id: id}, () => {
         setNotificationData(
            notificationData?.map((notification) =>
               notification?.id === id
                  ? { ...notification, isRead: true }
                  : notification
            )
         );
         setPopoverUnreadCount();
         // setLoadingMarkOneRead((prev) => ({
         //    ...prev,
         //    [id]: false
         // }));
         setLoadingOneRead((prev) => [...prev.filter((e) => e !== id)])

      }, (err) => {
         console.error(err);
         // setLoadingMarkOneRead((prev) => ({
         //    ...prev,
         //    [id]: false
         // }));
         setLoadingOneRead((prev) => [...prev.filter((e) => e !== id)])
      });
   }

   const markAllRead = () => {
      setLoadingMarkAllRead(true);

      httpService.post('/Notifications/read/all', {userId: user?.id}, () => {
         setNotificationData(
            notificationData?.map((notification) => ({ ...notification, isRead: true }))
         );
         setPopoverUnreadCountAll();
         setLoadingMarkAllRead(false);
      }, (err) => {
         console.log(err);
      })
   }

   useEffect(() => {
      setNotificationData(notifications);
      setLastFetchedItems(notifications?.length);
   },[notifications]);

   const fetchNextData = () => {
      setDataLoading(true);
      httpService.get(`/Notifications/all/${user?.id}?pageNumber=${page}&pageSize=10&unRead=${activeTab === 1 ? false : activeTab === 2 ? true : false }`, (res) => {
         setDataLoading(false);
         setHasMore(page < res?.metaData?.pageCount);
         const responseData = (res?.data);
         if(page === 1) {
            setNotificationData(responseData);
         } else {
            setNotificationData([...notificationData, ...responseData]);
         }
         setPageCount(res?.metaData?.pageNumber % res?.metaData?.totalItemCount);
         setLastFetchedItems(res?.data?.length)
         setPage(page+1)
      }, (err) => {
         console.log(err);
         setDataLoading(false);
      });
   }

   const changeNotifType = (nr) => {
      setActiveTab(nr)
      setPage(1);
      setNotificationData([]);
      // fetchNextData();
   }

   useEffect(() => {
      if(page === 1) {
         fetchNextData();
      }
   }, [page])

   useEffect(() => {
      if(newNotification) {
         let pushNew = {
            id: newNotification?.id,
            notificationTitle: newNotification?.notificationTitle,
            notificationBody: newNotification?.notificationBody,
            notificationType: newNotification?.notificationType,
            isRead: false,
            workspaceId: newNotification?.workspaceId,
            entityId: newNotification?.entityId,
            received: true,
         };
         let notifiationLastRemoved = notificationData.slice(0,-1)
         if(lastFetchedItems < 10) {
            setNotificationData([pushNew, ...notificationData])
         } else {
            setNotificationData([pushNew, ...notifiationLastRemoved])
         }
         setHasMore((lastFetchedItems + 1) >= 10)
         setLastFetchedItems(lastFetchedItems + 1);
         setPopoverIncCount();
         setNewNotification(false);
      }
   },[newNotification])

   return (
      <Popover
         className="arrow-menu"
         id="popover"
         open={Boolean(toggleBell)}
         anchorEl={toggleBell}
         onClose={handleCloseBell}
         style={{
            position: "fixed",
            top: "50px",
            maxHeight: "350px",
            right: "40px"
            // maxWidth: "400px"
         }}
         PaperProps={{
            style: {
               borderRadius: "8px"
            }
         }}
      >
         <div style={{overflow: 'hidden', borderRadius: '10px', boxShadow: '4px 8px 16px 0px #00266A33'}}>
            <div
               className="d-flex"
               style={{
                  gap: "30px",
                  alignItems: "center",
                  padding: "20px",
                  paddingBottom: '10px',
                  justifyContent: "space-between",
                  borderBottom: "1px solid #D9D9D9"
               }}
            >
               <p
                  style={{
                     fontWeight: 500,
                     fontSize: "18px",
                     fontFamily: "poppins",
                     color: "#3A3737",
                     margin: 0
                  }}
               >
                  Notifications
               </p>
               <div className="d-flex" style={{ gap: "10px", alignItems: "center" }}>
                     <div className={`mark-all-read ${notificationData?.every((notification) => notification?.isRead) ? "disabled" : ""}`}
                        onClick={!notificationData?.every((notification) => notification?.isRead) && markAllRead}
                     >
                        {
                           loadingMarkAllRead ?
                              <Spin/>
                           :
                              <NotificationCheckbox checked={
                                 notifications?.length > 0 &&
                                 notifications?.every((notification) => notification?.isRead)
                              }
                              small={true}
                              disabled={notifications?.every((notification) => notification?.isRead)}
                              />
                        }
                        <span
                           style={{
                              color: notifications?.length === 0 ? "#BFBFBF" : "#5492FF"
                           }}
                        >Mark all as read</span>
                     </div>
               </div>
            </div>
            <div id="notificationTarget" style={{overflowY: 'auto', maxHeight: '300px', backgroundColor: '#fff'}}>
               <>
               <div className="notificationType">
                  <div 
                     className={`notificationTypeWrapper ${activeTab === 1 && 'active'}`}
                     onClick={() => changeNotifType(1)}   
                  >
                     <span>All</span>
                  </div>
                  <div 
                     className={`notificationTypeWrapper ${activeTab === 2 && 'active'}`}
                     onClick={() => changeNotifType(2)}
                  >
                     <span>Unread</span>
                  </div>
               </div>
               {notificationData?.length !== 0 ? (

               <InfiniteScroll
                  dataLength={notificationData?.length}
                  hasMore={hasMore}
                  next={fetchNextData}
                  loader={<Spin style={{width: '100%', margin: '15px auto'}}/>}
                  scrollableTarget="notificationTarget"
               >
                  {
                     notificationData?.map((notification) => (
                        <div
                           className={`single-notification-item ${notification?.received && 'new-notification'}`}
                           key={notification?.id}
                           style={{
                              borderBottom: "1px solid #D9D9D9",
                              cursor: !notification?.isRead ? 'pointer' : 'default',
                           }}
                           onClick={() => !notification?.isRead && redirectNotification(notification)}
                           // onClick={() => redirectNotification(notification)}
                        >
                           <div
                              className="single-notification"
                              style={{
                                 padding: "12px 20px",
                                 transition: '0.2s',
                                 backgroundColor: notification?.isRead && "#F7F7F7"
                              }}
                           >
                              <div
                                 className="d-flex"
                                 style={{
                                    gap: "30px",
                                    alignItems: "flex-start",
                                    justifyContent: "space-between"
                                 }}
                              >
                                 <div className="d-flex flex-column">
                                    <span
                                       style={{
                                          fontSize: "16px",
                                          color: "#3A3737",
                                          margin: 0,
                                          wordBreak: "break-word",
                                          fontWeight: 500
                                       }}
                                    >
                                       {notification?.notificationTitle}
                                    </span>
                                    <span
                                       style={{
                                          fontSize: "14px",
                                          color: "#9E9FA2",
                                          margin: 0,
                                          wordBreak: "break-word",
                                          fontWeight: 400
                                       }}
                                    >
                                       {notification?.notificationBody}
                                    </span>
                                 </div>
   
                                 <div className="checkbox-comp" style={{marginTop: '5px'}}>
                                    {!notification?.isRead ? (
                                       loadingOneRead.includes(notification?.id) || loadingMarkAllRead ? (
                                          <Spin />
                                       ) : (
                                          <NotificationCheckbox
   
                                          />
                                       )
                                    ) : (
                                       <NotificationCheckbox
                                             checked={true}
                                             disabled={true}
                                          />
                                    )}
                                 </div>
                              </div>
                              <span
                                 style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    color: "#979797"
                                 }}
                              >
                                 {getTimeDifference(notification?.createdDate)}
                              </span>
                           </div>
                        </div>
                     ))
                  }
                  </InfiniteScroll>
               ) : (
                  <>
                     {
                        dataLoading 
                        ?
                        <Spin style={{width: '100%', margin: '15px auto'}}/>
                        :
                        <div
                           style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: "10px",
                              padding: "20px",
                              borderTop: "1px solid #DFE6FF"
                           }}
                        >
                           <img src={EmptyBox} alt="" width={80} height={50} />
                           <p
                              style={{
                                 margin: 0,
                                 fontWeight: 500,
                                 fontSize: "16px",
                                 color: "#3A3737"
                              }}
                           >
                              No notifications here!
                           </p>
                           <p style={{ margin: 0, fontSize: "14px", color: "#979797" }}>
                              Everything is up-to-date!
                           </p>
                        </div>

                     }
                  </>
               )}
               
               </>
            </div>
         </div>
      </Popover>
   );
};

export default NotificationPopover;
